// @ts-ignore - Allow building if type declarations aren't resolved locally
import { signOut } from 'next-auth/react';

export const performSignOut = async (redirectUrl: string = '/auth/login') => {
  try {
    if (typeof window !== 'undefined') {
      try {
        localStorage.removeItem('temporaryToken');
        localStorage.removeItem('rememberedEmail');
        localStorage.removeItem('rememberedPassword');
        localStorage.removeItem('justSubscribed');
        // Clear justSubscribed cookie
        document.cookie = 'justSubscribed=; path=/; max-age=0';
      } catch {}
      try {
        sessionStorage.clear();
      } catch {}
    }

    await signOut({ redirect: false, callbackUrl: redirectUrl });

    if (typeof window !== 'undefined') {
      window.location.assign(redirectUrl);
    }
  } catch (error) {
    console.error('Error during sign out:', error);
    if (typeof window !== 'undefined') {
      window.location.replace(redirectUrl);
    }
  }
};
